const EventParticipantInitialValues = (showData) => ({
  event_id: showData?.data?.event_id || "",
  team_id: showData?.data?.team_id || "",
  rank: showData?.data?.rank || "",
});

export default EventParticipantInitialValues;

export const rankTypeValues = [
  { value: "1", label: "1" },
  { value: "2", label: "2" },
  { value: "3", label: "3" },
  { value: "P", label: "P" },
];
